import { CollectionHelpers } from 'src/helpers/CollectionHelpers';
import type { SWRResponse } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { User } from 'models';

import { UserService } from 'services/UserService';

import { prepareConditionalSwrArgs } from './prepare-conditional-swr-args';

type UseUser = (
    useUserArguments: CollectionOrId | undefined,
    fetchNew?: boolean,
) => SWRResponse & {
    user: User | null;
};

const useUser: UseUser = (useUserArguments, fetchNew = true) => {
    const userId = CollectionHelpers.id(useUserArguments);

    const swr = useSWRImmutable(
        ...prepareConditionalSwrArgs({
            key: `/api/users/${userId}`,
            fetcher: () => UserService.get(userId!),
            condition: Boolean(userId) && fetchNew,
        }),
        !fetchNew && typeof useUserArguments === 'object' ? { fallbackData: useUserArguments as User } : {},
    );

    return {
        ...swr,
        user: swr.data as User | null,
    };
};

export { useUser };
